import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  API_URL_APPLICATIONS_FILES,
  ARTICLE_DETAIL,
  ARTICLE_INSERT,
} from 'manager/http-constants';
import { forkJoin } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {CONSTANT, IMAGE_EXTENSION, LOADING_KEY, NUMBER} from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-j203',
  templateUrl: './j203.component.html',
  styleUrls: ['./j203.component.scss', '../platform.component.scss'],
})

/**
 * 事例紹介記事登録(J203)
 * 事例紹介記事登録確認(G104)
 */
export class J203Component extends PlatformComponent {
  // 画面.入力フォーム
  j203InputForm: FormGroup = this.formBuilder.group({
    // タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'article',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 概要
    description: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'article',
          'description',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 掲載URL
    article_url: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'article',
          'article_url',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 記事サムネイル
    article_image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'article',
          'article_image',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
  });

  // 事例紹介記事IDを格納
  articleId: string = this.route.snapshot.queryParams.article_id;
  // file_path
  file_path: string = this.route.snapshot.queryParams.file_path;
  file_name: string = this.route.snapshot.queryParams.file_name;

  // 画像ID存在フラグ
  articleImgId = false;

  // 画像情報保持
  searchResultsList: any;

  // 確認画面表示フラグ(true=分科会申請登録確認(E205),false=分科会申請登録(E204))
  confirmationFlag = false;

  retouchFlg = false;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを事例紹介記事登録(J203)に変更する
    this.router.navigate(['pages/platform/j203/' + this.inputType], {
      queryParams: {
        screenId: 'j203',
        article_id: this.articleId,
      },
    });
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1004);

    // 編集初期表示
    this.setEditInitialData();
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(ARTICLE_DETAIL);

    // 事例紹介記事詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(ARTICLE_DETAIL, this.articleId, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, ARTICLE_DETAIL);
        if (this.commonService.checkNoneResponse(response)) {
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.j203InputForm,
          response.body
        );

        // 検索結果を保持
        this.searchResultsList = response.body;

        // 画像ID存在フラグを設定する
        if (this.searchResultsList.article_image.id != CONSTANT.EMPTY_STRING && this.searchResultsList.article_image.id.length != 0) {
          this.articleImgId = true;
          this.file_path = this.searchResultsList.article_image.file_path;
          this.file_name = this.searchResultsList.article_image.file_name;
        }
      });
  }

  /**
   * 事例紹介記事登録(J203)を表示する
   */
  public moveJ203(): void {
    // 事例紹介記事登録(J203)へ遷移
    this.router.navigate(['pages/platform/j203/' + this.inputType], {
      queryParams: {
        screenId: 'j203',
        information_id: this.articleId,
      },
    });

    // 事例紹介記事登録(J203)を表示する
    this.confirmationFlag = false;

    // 修正フラグを立てる
    this.retouchFlg = true;
  }

  /**
   * 事例紹介記事登録確認(J204)を表示する
   */
  public moveJ204(): void {
    // 表示する
    this.confirmationFlag = true;

    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const j203InputForm: any = JSON.parse(
      JSON.stringify(this.j203InputForm.value)
    );

    console.log('j203InputForm', j203InputForm);

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    const task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'article',
        j203InputForm
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 事例紹介記事登録確認(G104)へ遷移
      this.router.navigate(
        ['pages/platform/j203/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'j204',
            information_id: this.articleId,
            file_path: this.file_path,
            file_name: this.file_name
          },
        }
      );

      // 事例紹介記事登録確認(G104)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * ファイルアップロード
   * @param event ファイル情報
   * @param fileUpload ボタン動作状態
   * @param formName フォーム項目名
   */
  public uploadFile(event: any, fileUpload: any, formName: string) {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_APPLICATIONS_FILES);

    // ファイル情報からファイル名を取得
    const fileName = event.files[0].name;

    // 拡張子を取得
    const extension = event.files[0].name.substring(
      event.files[0].name.lastIndexOf(CONSTANT.PERIOD)
    );

    // 拡張子が".jpg" or ".jpeg" or ".png"か否か判定
    if (
      !(
        IMAGE_EXTENSION.JPG == extension ||
        IMAGE_EXTENSION.JPEG == extension ||
        IMAGE_EXTENSION.PNG == extension ||
        IMAGE_EXTENSION.JPG2 == extension ||
        IMAGE_EXTENSION.JPEG2 == extension ||
        IMAGE_EXTENSION.PNG2 == extension
      )
    ) {
      // 拡張子が".jpg" or ".jpeg" or ".png"
      // or".JPG" or ".JPEG" or ".PNG"以外の場合
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(
            MESSAGE_CODE.E00013,
            'jpg又はjpeg又はpng'
          ),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイルサイズの判定
    if (
      NUMBER.ZERO == event.files[0].size ||
      10485760 / 2 <= event.files[0].size
    ) {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // ファイルサイズが0KBの場合 または
      // 5MB以上の場合

      // 画像サイズエラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(
            MESSAGE_CODE.E00031,
            '5MB以内'
          ),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイル情報(base64)取得処理
    this.commonService.getBase64(event.files[0]).then((b64) => {
      const csize = 3000000; // 3MBで分割
      const lc = Math.floor(b64.length / csize) + 1; // 全ループ回数＝分割数
      let s: number;
      let e: number;
      let b64_konkai: string; // ループ毎に処理するbase64エンコード
      const b64_arr = []; // バッファ

      // 先頭部分の除去
      b64 = b64.replace(/^data:.*?;base64,/, '');

      for (var c = 0; c < lc; c++) {
        // 開始Indexと終了Index
        s = c * csize;
        e = s + csize;
        if (e >= b64.length) {
          e = b64.length;
        }

        // バッファ配列にセット
        b64_konkai = b64.substring(s, e);
        b64_arr.push(b64_konkai);
      }

      // ファイル登録を実施 処理部分
      const file_register = (b64_arr: Array<any>, lc: number) => {
        return new Promise((resolve) => {
          this.dbOperationService
            .insertFileResult(
              API_URL_APPLICATIONS_FILES,
              fileName,
              b64_arr[0],
              1,
              lc
            )
            .subscribe((response) => {
              // 画面.入力フォームにファイルIDを格納
              this.j203InputForm.get(formName).setValue(response.body.file_id);

              // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
              this.j203InputForm.get(formName).markAsDirty();

              // ファイルパスを保持
              this.file_path = response.body.file_path;

              // ファイル名を保持
              this.file_name = fileName;

              // 分割2回目～
              if (lc >= 2) {
                const arr = [];
                for (let c = 2; c <= lc; c++) {
                  arr.push(c);
                }
                (async () => {
                  for await (const num of arr) {
                    const res = await file2_register(num);
                  }
                  resolve('ok');
                })();
              } else { resolve('ok'); }

              const file2_register = (n: number) => {
                return new Promise((resolve2) => {
                  this.dbOperationService
                    .insertFileResult(
                      API_URL_APPLICATIONS_FILES,
                      fileName,
                      b64_arr[n - 1],
                      n,
                      lc
                    )
                    .subscribe((response) => {
                      resolve2(response.body);
                    });
                });
              };
            });
        });
      };

      // ファイル登録を実施
      (async () => {
        await file_register(b64_arr, lc);
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);
      })();
    });

    // 修正フラグを立てる
    this.retouchFlg = false;

    // 初期画像表示ID削除
    this.breakImgCaptionFlg(formName);
  }

  /**
   * アップロードファイル削除
   * @param formName フォーム項目名
   */
  public deleteFile(formName: string) {
    // 画面.入力フォームからファイル情報を削除
    this.j203InputForm.get(formName).setValue(CONSTANT.EMPTY_STRING);

    // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
    this.j203InputForm.get(formName).markAsDirty();

    // 修正フラグを立てる
    this.retouchFlg = false;

    // 初期画像表示ID削除
    this.breakImgCaptionFlg(formName);
  }

  /**
   * 初期画像IDフラグの削除
   * @param formName フォーム項目名
   */
  public breakImgCaptionFlg(formName: string): void {
    // フラグを折る
    if (this.articleImgId && formName == 'article_image') {
      this.articleImgId = false;
    }
  }

  /**
   * 事例紹介記事登録完了(G105)へ遷移する
   */
  public moveJ205(): void {
    // 事例紹介記事登録完了(G105)へ遷移
    this.router.navigate(['pages/platform/j205']);

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // 事例紹介記事登録を実施
      this.dbOperationService
        .insertData(ARTICLE_INSERT, this.j203InputForm.value)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 事例紹介記事登録完了(G105)へ遷移
            this.router.navigate(['pages/platform/j205']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 事例紹介記事登録(J203)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集の場合

      // 事例紹介記事更新を実施
      this.dbOperationService
        .updateData(
          ARTICLE_INSERT,
          this.articleId,
          this.j203InputForm.value
        )
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 事例紹介記事登録完了(G105)へ遷移
            this.router.navigate(['pages/platform/j205']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 事例紹介記事登録(J203)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }
}
